import React from 'react';
import { CgToggle } from 'modules/Common/toggle/CgToggle';

// Wraps the existing CgToggle so v2 forms use the same toggle the rest of
// the app already does. Boolean field semantics: value=true means "toggled".
export default function ToggleField({
  field,
  fieldState, // eslint-disable-line no-unused-vars
  id,
  offLabel,
  onLabel,
  disabled,
  loading,
  sizing = 'md',
}) {
  return (
    <div
      id={id}
      role="group"
      className="w-fit"
    >
      <CgToggle
        offLabel={offLabel}
        onLabel={onLabel}
        toggled={!!field.value}
        onClick={(next) => field.onChange(next)}
        disabled={disabled}
        loading={loading}
        sizing={sizing}
      />
    </div>
  );
}
